import React, { Component } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FadeIn from "react-fade-in";

import "./style.css";

export default class ConfirmationPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
    return (
      <div>
        <Header />
        <FadeIn>
          <div className="row confirm-container h-100 w-100 pt-5 pt-sm-5 mt-sm-4">
            <div className="col-lg-6 offset-lg-3 col-sm-8 offset-sm-2 my-auto pb-5">
              <div className="card shadow">
                <div className="card-header text-center">
                  <h4>{this.props.title}</h4>
                </div>
                <div className="row">
                  <div className="col m-4 mx-md-5 mt-md-5 text-left">
                    <p className={"lead " + this.props.textAlign}>
                      {this.props.message}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
        <Footer footerStyle="make-fixed" />
      </div>
    );
  }
}
